module.exports = __webpack_public_path__ + "img/turbo_on.f795f60f.png";